var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0253 0H6.97291C3.13745 0 0 3.13745 0 6.97291V27.0253C0 30.8608 3.13745 34 6.97291 34H27.0253C30.8608 34 33.9982 30.8625 33.9982 27.0271V6.97291C33.9982 3.13745 30.8608 0 27.0253 0ZM28.7437 8.02345C28.7437 8.98364 27.8491 9.76313 26.749 9.76313H16.7307C14.169 9.76313 12.0927 11.5754 12.0927 13.8094V20.1888C12.0927 22.4246 14.169 24.2351 16.7307 24.2351H18.5058C18.52 24.2351 18.5324 24.2351 18.5466 24.2351C18.5838 24.2351 18.6192 24.2351 18.6564 24.2351C20.6778 24.2351 22.4724 23.0907 23.08 21.4006C23.2466 20.9382 23.7833 20.4422 24.5735 20.4422H27.1812C28.0422 20.4422 28.7437 21.0534 28.7437 21.8063V24.0827C28.7437 24.8339 28.0422 25.4469 27.1812 25.4469H24.7577C22.4405 25.4469 20.4776 26.9403 20.164 28.9439C20.0524 29.6614 19.3402 30.2017 18.5076 30.2017H15.0141C14.0929 30.2017 13.3417 29.548 13.3417 28.742V28.6623C13.3417 26.4265 11.2654 24.616 8.70373 24.616H7.28647C6.16684 24.616 5.25802 23.8223 5.25802 22.8462V12.4648C5.25802 11.4886 6.16861 10.695 7.28647 10.695H9.20331C11.765 10.695 13.8413 8.88266 13.8413 6.64871V5.53616C13.8413 4.57597 14.7359 3.79648 15.8361 3.79648H26.7525C27.8526 3.79648 28.7473 4.57774 28.7473 5.53616V8.02168L28.7437 8.02345Z",
    fill: "url(#paint0_linear_1640_38277)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1640_38277",
    x1: 0,
    y1: 17,
    x2: 34,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0EB6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC25D4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLogo);
export default __webpack_public_path__ + "static/media/menu-logo.024f586b7648022e876bd00a062691b2.svg";
export { ForwardRef as ReactComponent };